import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classNames from 'classnames';
import s from './CricketScorecardV2.scss';

class Substitutes extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    battingTeamId: PropTypes.string.isRequired,
  };

  createSubstituesUi = () =>
    this.props.data
      .filter(item => this.props.battingTeamId === item.teamid)
      .map(subs => (
        <div className={s.listItem} key={subs.position}>
          <div className={s.content}>
            {/* <span>
              WK {fow.position} - {fow.outAt} {fow.outAt ? 'OVERS' : ''}
            </span> */}
            <p>{subs.playerin}</p>
          </div>
        </div>
      ));

  createSubstituesUiSlider = () =>
    this.props.data
      .filter(item => this.props.battingTeamId === item.teamid)
      .map(subs => (
        <div className={s.listItemWrapper}>
          <div className={s.listItem} key={subs.position}>
            <div className={s.content}>
              {/* <span>
                WK {fow.position} - {fow.outAt} {fow.outAt ? 'OVERS' : ''}
              </span> */}
              <p>{subs.playerin}</p>
            </div>
          </div>
        </div>
      ));

  render() {
    const settings = {
      slidesToShow: 3,
      slidesToScroll: 3,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      draggable: false,
      initialSlide: 0,
      infinite: false,
    };

    return (
      <div className={`${s.scorecardTable} ${s.wicketsFall}`}>
        <div className={s.tableHeading}>Substitutes</div>
        {this.props.isWapView ? (
          this.createSubstituesUi()
        ) : (
          <Slider {...settings}>{this.createSubstituesUiSlider()}</Slider>
        )}
      </div>
    );
  }
}

export default Substitutes;
